
<template>
    <div class="delmain" v-if="$store.state.dialogout">
        <div class="content">
            <div class="content-header">
                <div class="header-title">提示</div>
                <i class="el-icon-close" @click="isno"></i>
            </div>
            <div class="top">
                <div class="topicon">
                    <i class="el-icon-info"></i>
                </div>
                <div class="infos">登录失效，请重新登录</div>
            </div>
            <div class="btns">
                <!-- <div class="btnno" @click="isno">取消</div> -->
                <div class="btnok" @click="isok">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        isok() {
            this.$store.commit('Setdialogout', false)
            const hardwareId = this.$route.query.hardwareId // 获取 hardwareId 参数

            if (hardwareId) {
                this.$router.push({ path: '/login', query: { hardwareId } }) // 带上 hardwareId 参数
            } else {
                this.$router.push('/login') // 不带参数
            }
        },
        isno() {
            this.$store.commit('Setdialogout', false)
            const hardwareId = this.$route.query.hardwareId // 获取 hardwareId 参数
            if (hardwareId) {
                this.$router.push({ path: '/login', query: { hardwareId } }) // 带上 hardwareId 参数
            } else {
                this.$router.push('/login') // 不带参数
            }
        }
    }
}
</script>

<style lang="less" scoped>
.delmain {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #60626663;

    .content-header {
        height: 30px;
        line-height: 30px;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-icon-close {
            cursor: pointer;
        }

        .header-title {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #606266;
            line-height: 20px;
        }
    }

    .content {
        // margin-bottom: 30vh;
        padding: 12px 29px 22px 29px;
        background: #ffffff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
        border-radius: 12px;

        .top {
            display: flex;
            align-items: center;
            justify-content: left;
            margin: 16px 0 35px 0;

            .topicon {
                i {
                    font-size: 18px;
                    color: #c5d0de;
                    line-height: 24px;
                }
            }

            .infos {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                color: #606266;
                line-height: 24px;
                margin-left: 10px;
            }
        }

        .btns {
            display: flex;
            align-items: center;
            justify-content: right;

            div {
                width: 80px;
                height: 36px;
                border-radius: 4px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 36px;
                text-align: center;
                cursor: pointer;
            }

            .btnno {
                background: linear-gradient(360deg, #eaeef3 0%, #ffffff 100%);
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
                border: 1px solid #ced0da;
                color: #354052;
            }

            .btnok {
                background: linear-gradient(360deg, #157bd1 0%, #2da1f8 100%);
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
                border: 1px solid #1585d8;
                color: #ffffff;
                margin-left: 12px;
            }
        }
    }
}
</style> 